<template>
  <div>
    <div class="block">
      <div class="block-header">
        <h3 class="block-title"><i class="fas fa-map-marker-alt"></i> {{ $t('addresses.index') }}</h3>
        <div class="block-options">
            <b-btn v-b-modal.addaddress size="sm" variant="primary" class="float-right">{{ $t('addresses.add') }}</b-btn>
        </div>
      </div>
        <table class="table table-hover">
          <thead>
            <th>#</th>
            <th>{{ $t('app.type') }}</th>
            <th>{{ $t('addresses.address') }}</th>
            <th>{{ $t('addresses.last_contact') }}</th>
            <th>{{ $t('addresses.created_at') }}</th>
            <th>{{ $t('app.action') }}</th>
          </thead>
          <tbody>
            <tr v-for="(address, index) in addresses" v-if="!isProcessing">
              <td>{{ index+1 }}</td>
              <td>{{ address.type ? address.type.name: 'Не определен'  }}</td>
              <td>{{ address.address }}</td>
              <td>{{ address.last_contact | datetimeFormat }}</td>
              <td>{{ address.created_at | datetimeFormat }}</td>
              <td>
                <div class="btn-group">
                  <button @click.prevent="initUpdate(index)" class="btn btn-primary btn-sm d-inline">
                    <i class="fa fa-edit"></i>
                  </button>
                  <button @click.prevent="handleDelete(address.id)" class="btn btn-danger btn-sm " :disabled="isProcessing">
                    <i class="fa fa-times-circle"></i>
                  </button>
                </div>
              </td>
            </tr>
            <tr v-if="isProcessing">
              <td colspan="9" class="text-center">
                <loader-wave/>
              </td>
            </tr>
          </tbody>
        </table>
    </div>
    <b-modal id="addaddress" size="lg" :title="$t('addresses.add_title')" ref="modalAddAddress" @ok="handleStore" :ok-title="$t('buttons.ok')" :cancel-title="$t('buttons.cancel')" @ok-disabled="isProcessing">
      <form @submit.stop.prevent="storeAddress">
        <div class="form-group">
          <label for="StoreAddress" class="col-form-label">{{ $t('addresses.address') }}</label>
          <input type="text" class="form-control" v-model="address.address" :class="{'is-invalid': errors.address }" id="StoreAddress">
          <span v-if="errors.address" class="invalid-feedback">
              <strong>{{ errors.address ? errors.address[0] : '' }}</strong>
          </span>
        </div>
        <div class="form-group">
          <label for="StoreType" class="col-form-label">{{ $t('app.type') }}</label>
          <select v-model="address.type_id" class="form-control" id="StoreType" required>
            <option selected="true" value="" disabled>{{ $t('placeholder.select_type') }}</option>
            <option v-for="type in adminListAddressTypes" :value="type.id" :key="type.id">
              {{ type.name }}
            </option>
          </select>
        </div>
      </form>
    </b-modal>
    <b-modal id="updaddress" size="lg" :title="$t('addresses.edit_title')" ref="modalUpdateAddress" @ok="handleUpdate" @shown="fetchAddresses" :ok-title="$t('buttons.save')" :cancel-title="$t('buttons.cancel')" @ok-disabled="isProcessing">
      <form @submit.stop.prevent="updateAddress">
          <div class="form-group">
            <label for="updateAddress" class="col-form-label">{{ $t('addresses.address') }}</label>
            <input type="text" class="form-control" v-model="update_address.address" :class="{'is-invalid': update_errors.address }" id="updateAddress">
            <span v-if="update_errors.address" class="invalid-feedback">
                <strong>{{ update_errors.address ? update_errors.address[0] : '' }}</strong>
            </span>
          </div>
          <div class="form-group">
            <label for="updateType" class="col-form-label">{{ $t('app.type') }}</label>
            <select v-model="update_address.type_id" class="form-control" id="updateType" required>
              <option v-for="type in adminListAddressTypes" :value="type.id" :key="type.id" :selected="update_address.type_id == type.id">
                {{ type.name }}
              </option>
            </select>
          </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      addresses: [],
      address: {
        address: '',
        type_id: '',
        status_id: '',
      },
      update_address: [],
      errors: {},
      update_errors: {},
      isProcessing: false,
    };
  },
  computed: {
    ...mapGetters([
      'adminDebtor',
      'adminListAddressTypes',
    ]),
  },
  mounted() {
    this.fetchAddresses();
    this.GET_ADMIN_LIST_ADDRESS_TYPES();
  },
  methods: {
    ...mapActions([
      'GET_ADMIN_LIST_ADDRESS_TYPES',
    ]),
    fetchAddresses() {
      this.isProcessing = true;
      axios.get(`/admin/debtors/${this.$route.params.id}/addresses`)
        .then((res) => {
          this.addresses = res.data.addresses;
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },

    clearModal() {
      this.address.address = '';
      this.address.type_id = '';
      this.address.status_id = '';
      this.errors = {};
    },

    clearUpdateModal() {
      this.update_address = {};
      this.update_errors = {};
    },

    initUpdate(index) {
      this.update_errors = {};
      this.$refs.modalUpdateAddress.show();
      this.update_address = this.addresses[index];
    },

    handleStore(evt) {
      evt.preventDefault();
      this.storeAddress();
    },

    handleUpdate(evt) {
      evt.preventDefault();
      this.updateAddress();
    },

    handleDelete(id) {
      window.Swal.fire({
        title: this.$t('alerts.are_you_sure'),
        text: this.$t('alerts.want_to_delete'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('alerts.delete_it'),
        cancelButtonText: this.$t('field.cancel'),
      }).then((result) => {
        if (result.value) {
          this.deleteAddress(id);
        }
      });
    },

    storeAddress() {
      this.isProcessing = true;
      axios.post(`/admin/debtors/addresses/${this.$route.params.id}`, this.address)
        .then((res) => {
          if (res.status === 201) {
            this.$refs.modalAddAddress.hide();
            this.clearModal();
            window.Swal.fire(this.$t('alerts.success'), res.data.message, 'success');
            this.fetchAddresses();
          }
        })
        .catch((err) => {
          this.errors = this.laravelValidation(err);
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },

    updateAddress() {
      this.isProcessing = true;
      axios.put(`/admin/debtors/addresses/${this.update_address.id}`, this.update_address)
        .then((res) => {
          if (res.status === 200) {
            this.$refs.modalUpdateAddress.hide();
            this.clearUpdateModal();
            window.Swal.fire(this.$t('alerts.success'), res.data.message, 'success');
            this.fetchAddresses();
          }
        })
        .catch((err) => {
          this.update_errors = this.laravelValidation(err);
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },

    deleteAddress(id) {
      this.isProcessing = true;
      axios.delete(`/admin/debtors/addresses/${id}`)
        .then((res) => {
          if (res.status === 204) {
            window.Swal.fire(this.$t('alerts.success'), res.data.message, 'success');
            this.fetchAddresses();
          }
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },
  },
};
</script>
